import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component,
} from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { BaseGlobalSegmentComponent } from '../../../common/_base-global-segment.component';
import { AccountInformationService } from '../../account-information.service';
import { InformationPageService } from '../../../information-page/information-page.service';
import { PermissionsService } from 'shared/permissions/permissions.service';
import { PROFILE_NAME } from '../../variables';

@Component({
  providers: [AccountInformationService],
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseAccountSegmentComponent extends BaseGlobalSegmentComponent {
  constructor(
    protected accountInformationService: AccountInformationService,
    protected informationPageService: InformationPageService,
    protected ref: ChangeDetectorRef,
  ) {
    super(informationPageService, ref);
  }

  // protected:
  protected refreshSegmentData() {
    const segmentData = this.accountInformationService.getSegmentData(this.name);
    this.segmentData = _.orderBy(segmentData, ['sequence']);
  }

  protected refreshData(): Observable<any> {
    return this.accountInformationService.getData(this.name);
  }

  // handlers
  onCancel(event: any) {
    this.data = {...this.sourceData};
    if (this.form) { this.form.markAsPristine(); }
    this.ref.markForCheck();
  }
}
